// import React, { useEffect, useState } from "react";

// const CountdownTimer = ({ targetDate }) => {
//   const [timeLeft, setTimeLeft] = useState(getTimeRemaining(targetDate));

//   useEffect(() => {
//     const timer = setInterval(() => {
//       const updatedTime = getTimeRemaining(targetDate);
//       setTimeLeft(updatedTime);

//       if (updatedTime.total <= 0) clearInterval(timer);
//     }, 1000);

//     return () => clearInterval(timer);
//   }, [targetDate]);

//   if (timeLeft.total <= 0) {
//     return (
//       <div className="text-center text-red-600 font-bold text-xl">
//         Time’s up!
//       </div>
//     );
//   }

//   return (
//     <div className="flex justify-center space-x-4 bg-gray-800 text-white p-4 rounded-xl shadow-md mb-2">
//       <TimeBox label="Days" value={timeLeft.days} />
//       <TimeBox label="Hours" value={timeLeft.hours} />
//       <TimeBox label="Minutes" value={timeLeft.minutes} />
//       <TimeBox label="Seconds" value={timeLeft.seconds} />
//     </div>
//   );
// };

// const TimeBox = ({ label, value }) => (
//   <div className="text-center">
//     <div className="text-3xl font-bold">{String(value).padStart(2, "0")}</div>
//     <div className="text-sm">{label}</div>
//   </div>
// );

// const getTimeRemaining = (targetDate) => {
//   const total = Date.parse(targetDate) - Date.now();
//   const seconds = Math.floor((total / 1000) % 60);
//   const minutes = Math.floor((total / 1000 / 60) % 60);
//   const hours = Math.floor((total / 1000 / 60 / 60) % 24);
//   const days = Math.floor(total / (1000 * 60 * 60 * 24));

//   return {
//     total,
//     days,
//     hours,
//     minutes,
//     seconds,
//   };
// };

// export default CountdownTimer;


// import React, { useEffect, useState } from "react";

// const CountdownTimer = ({ targetDate }) => {
//   const [timeLeft, setTimeLeft] = useState(getTimeRemaining(targetDate));

//   useEffect(() => {
//     const timer = setInterval(() => {
//       const updatedTime = getTimeRemaining(targetDate);
//       setTimeLeft(updatedTime);

//       if (updatedTime.total <= 0) clearInterval(timer);
//     }, 1000);

//     return () => clearInterval(timer);
//   }, [targetDate]);

//   if (timeLeft.total <= 0) {
//     return (
//       <div className="text-center text-red-600 font-semibold text-base">
//         Time’s up!
//       </div>
//     );
//   }

//   return (
//     <div className="flex justify-center space-x-2 bg-gray-800 text-blue-500 px-3 py-2 rounded-lg shadow-sm mb-2">
//       <TimeBox label="Days" value={timeLeft.days} />
//       <TimeBox label="Hours" value={timeLeft.hours} />
//       <TimeBox label="Minutes" value={timeLeft.minutes} />
//       <TimeBox label="Seconds" value={timeLeft.seconds} />
//     </div>
//   );
// };

// const TimeBox = ({ label, value }) => (
//   <div className="text-center">
//     <div className="text-xl font-semibold">{String(value).padStart(2, "0")}</div>
//     <div className="text-xs">{label}</div>
//   </div>
// );

// const getTimeRemaining = (targetDate) => {
//   const total = Date.parse(targetDate) - Date.now();
//   const seconds = Math.floor((total / 1000) % 60);
//   const minutes = Math.floor((total / 1000 / 60) % 60);
//   const hours = Math.floor((total / 1000 / 60 / 60) % 24);
//   const days = Math.floor(total / (1000 * 60 * 60 * 24));

//   return {
//     total,
//     days,
//     hours,
//     minutes,
//     seconds,
//   };
// };

// export default CountdownTimer;


import React, { useEffect, useState } from "react";

const CountdownTimer = ({ targetDate }) => {
  const [mode, setMode] = useState("real"); // "real" | "fallback"
  const [timerDate, setTimerDate] = useState(getInitialTarget(targetDate));
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining(timerDate));

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const realTargetTime = Date.parse(targetDate);
      const realTimeLeft = realTargetTime - now;

      if (realTimeLeft > 0) {
        // If the real target date becomes valid again
        if (mode === "fallback") {
          setMode("real");
          setTimerDate(new Date(targetDate));
          setTimeLeft(getTimeRemaining(new Date(targetDate)));
          return;
        }
      }

      if (mode === "real") {
        const timeRemaining = realTargetTime - now;
        if (timeRemaining <= 0) {
          // Switch to fallback mode
          const fallbackTarget = new Date(now + 24 * 60 * 60 * 1000);
          setMode("fallback");
          setTimerDate(fallbackTarget);
          setTimeLeft(getTimeRemaining(fallbackTarget));
        } else {
          setTimeLeft(getTimeRemaining(new Date(targetDate)));
        }
      } else if (mode === "fallback") {
        const fallbackTimeLeft = Date.parse(timerDate) - now;
        if (fallbackTimeLeft <= 0) {
          const nextFallback = new Date(now + 24 * 60 * 60 * 1000);
          setTimerDate(nextFallback);
          setTimeLeft(getTimeRemaining(nextFallback));
        } else {
          setTimeLeft(getTimeRemaining(timerDate));
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [mode, timerDate, targetDate]);

  return (
    <div className="flex justify-center space-x-2 bg-gray-800 text-blue-500 px-3 py-2 rounded-lg shadow-sm mb-2">
      <TimeBox label="Days" value={timeLeft.days} />
      <TimeBox label="Hours" value={timeLeft.hours} />
      <TimeBox label="Minutes" value={timeLeft.minutes} />
      <TimeBox label="Seconds" value={timeLeft.seconds} />
    </div>
  );
};

const TimeBox = ({ label, value }) => (
  <div className="text-center">
    <div className="text-xl font-semibold">{String(value).padStart(2, "0")}</div>
    <div className="text-xs">{label}</div>
  </div>
);

const getTimeRemaining = (targetDate) => {
  const total = Date.parse(targetDate) - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / 1000 / 60 / 60) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return { total, days, hours, minutes, seconds };
};

const getInitialTarget = (targetDate) => {
  const now = Date.now();
  const parsed = Date.parse(targetDate);
  return parsed > now ? new Date(parsed) : new Date(now + 24 * 60 * 60 * 1000);
};

export default CountdownTimer;
